import { lazy } from 'react'

// Code-Splitting pro Route. Eigene Datei, damit router.tsx nur Nicht-Komponenten exportiert (Fast Refresh).
export const SupportPage = lazy(() => import('@/pages/SupportPage'))
export const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'))
export const ImpressumPage = lazy(() => import('@/pages/ImpressumPage'))
export const DatenschutzPage = lazy(() => import('@/pages/DatenschutzPage'))
